import { render, staticRenderFns } from "./receipt-card-item-info.vue?vue&type=template&id=029bf7b6"
import script from "./receipt-card-item-info.vue?vue&type=script&lang=js"
export * from "./receipt-card-item-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports